import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaApple, FaGooglePlay } from 'react-icons/fa';

// 1. IMPORTY
import { useCookieConsent } from '../../contexts/CookieConsentContext';
import { useDeviceType } from '../../hooks/useDeviceType';
import logo from '../../img/logo_full.png';
import NotebookBackground from '../../img/NotebookBackground';

const ThankYouPage = () => {
  const deviceType = useDeviceType();
  const pixelLibRef = useRef(null);
  const { consentState } = useCookieConsent();

  const IS_MOBILE_BUILD = process.env.REACT_APP_IS_MOBILE === 'true';

  // Linki
  const APP_STORE_LINK = "https://apps.apple.com/pl/app/matematly-matura-z-matematyki/id6754283687?action=write-review"; 
  const GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=matematly.pl"; 

  // --- ANALITYKA ---
  useEffect(() => {
    if (IS_MOBILE_BUILD || !consentState.marketing) return;
    const pixelId = process.env.REACT_APP_TIKTOK_PIXEL_ID;
    if (pixelId) {
      import('tiktok-pixel').then((module) => {
          module.default.init(pixelId, {}, { debug: false });
          module.default.pageView();
      });
    }
  }, [IS_MOBILE_BUILD, consentState.marketing]);

  const handleClick = (platform) => {
    if (!pixelLibRef.current || IS_MOBILE_BUILD) return;
    try {
      pixelLibRef.current.track('ClickButton', { content_name: `Rate on ${platform}` });
    } catch (e) {}
  };

  // === JEDEN WSPÓLNY STYL DLA OBU PRZYCISKÓW ===
  // Białe tło, ciemny tekst, cień - klasyczny "Store Badge"
  const commonButtonClasses = "flex items-center justify-start gap-4 w-full md:w-[260px] px-6 py-4 rounded-xl shadow-lg transform transition-all duration-300 hover:scale-105 hover:shadow-2xl active:scale-95 bg-white text-[#0a101f] hover:bg-gray-50 border border-transparent";

  return (
    <div className="relative min-h-screen w-full overflow-hidden font-sans bg-blue-950 flex flex-col items-center justify-center">
      
      {/* Tło */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
          <NotebookBackground />
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 flex flex-col items-center text-center">

        {/* LOGO */}
        <Link to="/" className="mb-10 hover:opacity-80 transition-opacity">
            <img src={logo} alt="Matematly" className="h-16 md:h-20 w-auto" />
        </Link>

        {/* NAGŁÓWEK */}
        <h1 className="text-4xl md:text-5xl font-bold text-[#F0F0F0] font-apotek uppercase tracking-wide mb-6 leading-tight">
          Dzięki za <span className="text-[#E09F2E]">zaufanie!</span>
        </h1>

        <p className="text-blue-100/80 text-lg max-w-lg mb-4 font-sans leading-relaxed">
          Twój głos pomaga nam docierać do innych maturzystów i pokonać maturę z matematyki! <br/>
          <br/>
          <strong>Wybierz swój sklep:</strong>
        </p>

        {/* --- PRZYCISKI (IDENTYCZNE) --- */}
        <div className="flex flex-col md:flex-row gap-6 w-full justify-center items-center">
            
            {/* iOS BUTTON */}
            <a 
                href={APP_STORE_LINK} 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={() => handleClick('iOS')}
                className={commonButtonClasses}
            >
                <FaApple size={32} className="flex-shrink-0" />
                <div className="text-left flex flex-col">
                    <span className="text-[10px] uppercase tracking-wider opacity-60 font-bold leading-none mb-1">Oceń w</span>
                    <span className="text-xl font-bold leading-none font-sans">App Store</span>
                </div>
            </a>

            {/* ANDROID BUTTON */}
            <a 
                href={GOOGLE_PLAY_LINK} 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={() => handleClick('Android')}
                className={commonButtonClasses}
            >
                {/* Używamy zwykłego koloru tekstu dla spójności, lub brandowego jeśli wolisz */}
                <FaGooglePlay size={28} className="flex-shrink-0" /> 
                <div className="text-left flex flex-col">
                    <span className="text-[10px] uppercase tracking-wider opacity-60 font-bold leading-none mb-1">Oceń w</span>
                    <span className="text-xl font-bold leading-none font-sans">Google Play</span>
                </div>
            </a>

        </div>

        {/* POWRÓT */}
        <div className="mt-16">
            <Link to="/" className="text-blue-100/30 text-xs hover:text-white transition-colors underline underline-offset-4">
                Wróć do strony głównej
            </Link>
        </div>

      </div>
      
      <footer className="absolute bottom-4 w-full text-center text-[10px] text-[#F0F0F0]/20 font-sans">
        © {new Date().getFullYear()} Matematly.
      </footer>
    </div>
  );
};

export default ThankYouPage;